import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Activities from "./components/activities/main";
import Performance from "./components/performance/main";

const Activity = () => {
  return (
    <Box
      sx={{
        padding: "1.63rem 0rem 0rem 0rem",
        position: "fixed",
      }}
    >
      <Grid container rowSpacing={{ xs: 4 }}>
        <Box
          sx={{ marginTop: "1.75rem", overflow: "hidden" }}
          data-tut="activities"
        >
          <Activities />
        </Box>

        <Box
          sx={{
            marginTop: "2rem",
            overflowY: "hidden",
          }}
          data-tut="topAgent"
        >
          <Performance />
        </Box>

        <Grid item xs={12}></Grid>
      </Grid>
    </Box>
  );
};
export default Activity;
